var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmpowerment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.9572 20.5C30.9572 20.5 30.9572 20.5 29.0572 18C26.8572 15.1 23.6072 13 19.7072 13C13.4822 13 8.45715 18.025 8.45715 24.25C8.45715 26.575 9.15715 28.725 10.3572 30.5C12.3822 33.525 30.9572 53 30.9572 53M30.9572 20.5C30.9572 20.5 30.9572 20.5 32.8572 18C35.0572 15.1 38.3072 13 42.2072 13C48.4322 13 53.4572 18.025 53.4572 24.25C53.4572 26.575 52.7572 28.725 51.5572 30.5C49.5322 33.525 30.9572 53 30.9572 53",
    stroke: "white",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpowerment);
export default __webpack_public_path__ + "static/media/empowerment.80199534bbbf8532854157f30c57c132.svg";
export { ForwardRef as ReactComponent };